import React, { useReducer } from 'react'
import MapReducer from './MapReducer'
import MapContext from './MapContex'

import { ADD_DATA, CLOSE_MODAL } from '../types'

const MapState = (props) => {

	const initialState = {
		data: [],
		modal: false
	}

	const [state, dispatch] = useReducer(MapReducer, initialState)
	const add_data = (data) => {

		dispatch({
			type: ADD_DATA,
			payload: data
		})
	}

	const close_modal = () => {
		dispatch({
			type: CLOSE_MODAL
		})
	}
	return (
		<MapContext.Provider
			value={{
				modal: state.modal,
				data: state.data,
				add_data,
				close_modal
			}}
		>
			{props.children}
		</MapContext.Provider>
	)
}

export default MapState